/* ==========================================================================
   Country / language selectors: auto-submit their Shopify localization form
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-country-select], [data-language-select]');
    if (!select) return;
    var form = select.closest('form');
    if (form) form.submit();
  });
})();
